import React from "react";
import { PRICING_PAGE_URL } from "./FeatureUpgradeModal";

/**
 * What a Starter owner sees when they open the AI Visibility Manager (SGL-449).
 *
 * Every Brand gets the agent so Starter owners can see what Pro adds, but only
 * Pro can chat with it (chat-service refuses with PLAN_REQUIRED). So this shows
 * what it does and one way to upgrade, never a chat box that fails on send.
 * Each line is a capability PRODUCT_IDEAS.md lists as working today.
 */
const DOES = [
  "Checks whether ChatGPT, Gemini and Perplexity recommend your business",
  "Shows who gets recommended instead of you",
  "Reads your Google Search Console: what people search, clicks and position",
  "Finds the questions customers ask that you're missing from, and what to do about each",
];

export const VisibilityManagerPreview: React.FC = () => (
  <div className="flex h-full w-full items-center justify-center overflow-y-auto px-4 py-8">
    <div className="w-full max-w-[520px] rounded-2xl border border-theme-border bg-theme-surface p-6 text-left shadow-sm">
      <span className="inline-block rounded-full bg-brand-primary/10 px-2.5 py-0.5 text-[12px] font-semibold text-brand-primary">
        Pro
      </span>
      <h2 className="mt-3 text-[20px] font-semibold text-theme-fg">Your AI Visibility Manager</h2>
      <p className="mt-1 text-[14px] text-theme-fg-muted">
        More customers now ask AI who to hire instead of searching Google. This agent finds out whether
        AI recommends you.
      </p>
      <ul className="mt-4 flex flex-col gap-2.5">
        {DOES.map((line) => (
          <li key={line} className="flex items-start gap-2 text-[14px] text-theme-fg">
            <span className="material-icons mt-0.5 text-[18px] text-brand-primary" aria-hidden="true">check_circle</span>
            <span>{line}</span>
          </li>
        ))}
      </ul>
      <button
        type="button"
        onClick={() => window.open(PRICING_PAGE_URL, "_blank", "noopener,noreferrer")}
        className="mt-6 h-11 w-full rounded-xl bg-brand-primary px-5 text-[15px] font-semibold text-white shadow-sm transition hover:bg-brand-primary-hover"
      >
        Upgrade to Pro
      </button>
      <p className="mt-2 text-center text-[12px] text-theme-fg-muted">Included in Sagelyn Pro, $48.99/month.</p>
    </div>
  </div>
);

export default VisibilityManagerPreview;
